import React from 'react'
import { Link } from 'react-router-dom'
import './CmSlider.css'
import { useKeenSlider } from "keen-slider/react"


function CmSlider() {
    const [sliderRef] = useKeenSlider({
        breakpoints: {
            "(min-width: 576px)": {
              slides: { perView: 2, spacing: 15 },
            },
            "(min-width: 1024px)": {
              slides: { perView: 4, spacing: 15 },
            },
          },
        slides: {
            perView: 1,
            spacing: 15,
          },
      })
  return (
   <section className='cm_slider spacing'   >
    <div className="cm_slider-inner container">
        <h4>And this is what we do.</h4>
        <div className="content">
            <div className="slider keen-slider" ref={sliderRef}>

            <div className="keen-slider__slide">
                <Link to='/services#product-engineering' className="s_items ">
                    <div  className="s_item_inner ">
                        <div className="title"> 
                        <h5>Technology</h5></div>
                        <div className="btm_title"> 
                        <h4>Products Development</h4></div>

                    </div>
                </Link>
                </div>
                <div className="keen-slider__slide">
                <Link to='/services#customer-experience' className="s_items ">
                    <div className="s_item_inner">
                        <div className="title"> 
                        <h5>Design</h5></div>
                        <div className="btm_title"> 
                        <h4>Customer Experience</h4></div>

                    </div>
                </Link>
                </div>
               
                <div className="keen-slider__slide">
                <Link to='/services#digital-growth' className="s_items ">
                    <div  className="s_item_inner" >
                        <div className="title"> 
                        <h5>Marketing</h5></div>
                        <div className="btm_title"> 
                        <h4>Digital Growth</h4></div>

                    </div>
                </Link>
                </div>
            </div>
            <div className="last-cart">
                <div className="lc_inner">
                    <Link className='animateLine' to='/services'>In details</Link>
                </div>
            </div>
        </div>
    </div>
   </section>
  )
}

export default CmSlider